import { render } from "./buttonset.vue?vue&type=template&id=52838622&scoped=true"
import script from "./buttonset.vue?vue&type=script&lang=js"
export * from "./buttonset.vue?vue&type=script&lang=js"

import "./buttonset.vue?vue&type=style&index=0&id=52838622&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52838622"]])

export default __exports__